import { c as _c } from "react/compiler-runtime";
import { IS_DEV } from '@onefootprint/dev-tools';
import { IcoChevronDown16 } from '@onefootprint/icons';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AuthTokenForm from '../components/auth-token-form';
import CardFootnote from '../components/card-footnote';
import CardHeading from '../components/card-heading';
import ContainerBox from '../components/container-box';
import DemoDialog from '../components/demo-dialog';
import EmailForm from '../components/email-form';
import Layout from '../components/layout';
import OrDivider from '../components/or-divider';
import SocialButtons from '../components/social-buttons';
import useCaptureTrackingParams from '../use-capture-tracking-params';
import useCaptureQueryParams from './use-capture-query-params';
type SignInProps = {
  showAuthTokenForm?: boolean;
  authTokenFormOpen?: boolean;
  accountNotFound?: boolean;
  onDismissAccountNotFound?: () => void;
};
const SignIn = t0 => {
  const $ = _c(45);
  const {
    showAuthTokenForm: t1,
    authTokenFormOpen: t2,
    accountNotFound: t3,
    onDismissAccountNotFound
  } = t0;
  const showAuthTokenForm = t1 === undefined ? false : t1;
  const authTokenFormOpen = t2 === undefined ? false : t2;
  const accountNotFound = t3 === undefined ? false : t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      keyPrefix: "signIn"
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const {
    t
  } = useTranslation("authentication", t4);
  const [demoOpen, setDemoOpen] = useState(false);
  let t5;
  if ($[1] !== t) {
    t5 = t(_temp);
    $[1] = t;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== t5) {
    t6 = <Head><title>{t5}</title></Head>;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t) {
    t7 = t(_temp2);
    $[5] = t;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t) {
    t8 = t(_temp3);
    $[7] = t;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t7 || $[10] !== t8) {
    t9 = <CardHeading title={t7} description={t8} />;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  let t11;
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="mt-2"><SocialButtons /></div>;
    t11 = <OrDivider />;
    t12 = <EmailForm />;
    $[12] = t10;
    $[13] = t11;
    $[14] = t12;
  } else {
    t10 = $[12];
    t11 = $[13];
    t12 = $[14];
  }
  let t13;
  if ($[15] !== authTokenFormOpen || $[16] !== showAuthTokenForm || $[17] !== t) {
    t13 = showAuthTokenForm ? <details className="fp-auth-rule group border-t pt-4" open={authTokenFormOpen}><summary className="flex cursor-pointer list-none items-center gap-1 text-caption-2 text-tertiary hover:text-primary [&::-webkit-details-marker]:hidden"><IcoChevronDown16 className="transition-transform group-open:rotate-180" />{t(_temp4)}</summary><div className="pt-4"><AuthTokenForm /></div></details> : null;
    $[15] = authTokenFormOpen;
    $[16] = showAuthTokenForm;
    $[17] = t;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t13 || $[20] !== t9) {
    t14 = <ContainerBox>{t9}{t10}{t11}{t12}{t13}</ContainerBox>;
    $[19] = t13;
    $[20] = t9;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t) {
    t15 = t(_temp5);
    $[22] = t;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = () => setDemoOpen(true);
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t) {
    t17 = t(_temp6);
    $[25] = t;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t17) {
    t18 = <button type="button" className="fp-auth-link cursor-pointer text-accent" onClick={t16}>{t17}</button>;
    $[27] = t17;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t15 || $[30] !== t18) {
    t19 = <CardFootnote>{t15}{" "}{t18}</CardFootnote>;
    $[29] = t15;
    $[30] = t18;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  const t20 = demoOpen || accountNotFound;
  let t21;
  if ($[32] !== onDismissAccountNotFound) {
    t21 = () => {
      setDemoOpen(false);
      onDismissAccountNotFound?.();
    };
    $[32] = onDismissAccountNotFound;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] !== accountNotFound || $[35] !== t20 || $[36] !== t21) {
    t22 = <DemoDialog open={t20} accountNotFound={accountNotFound} onClose={t21} />;
    $[34] = accountNotFound;
    $[35] = t20;
    $[36] = t21;
    $[37] = t22;
  } else {
    t22 = $[37];
  }
  let t23;
  if ($[38] !== t14 || $[39] !== t19 || $[40] !== t22) {
    t23 = <Layout>{t14}{t19}{t22}</Layout>;
    $[38] = t14;
    $[39] = t19;
    $[40] = t22;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== t23 || $[43] !== t6) {
    t24 = <>{t6}{t23}</>;
    $[42] = t23;
    $[43] = t6;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  return t24;
};
const SignInPage = () => {
  const $ = _c(7);
  const router = useRouter();
  const requestedAuthTokenForm = router.query["show-auth-token-form"] === "true";
  useCaptureQueryParams();
  useCaptureTrackingParams();
  let t0;
  if ($[0] !== router) {
    t0 = () => {
      const {
        loginError: _loginError,
        ...query
      } = router.query;
      router.replace({
        pathname: router.pathname,
        query
      }, undefined, {
        shallow: true
      });
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const dismissAccountNotFound = t0;
  const t1 = IS_DEV || requestedAuthTokenForm;
  const t2 = router.query.loginError === "account-not-found";
  let t3;
  if ($[2] !== dismissAccountNotFound || $[3] !== requestedAuthTokenForm || $[4] !== t1 || $[5] !== t2) {
    t3 = <SignIn showAuthTokenForm={t1} authTokenFormOpen={requestedAuthTokenForm} accountNotFound={t2} onDismissAccountNotFound={dismissAccountNotFound} />;
    $[2] = dismissAccountNotFound;
    $[3] = requestedAuthTokenForm;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export { SignIn };
export default SignInPage;
function _temp($) {
  return $.pageTitle;
}
function _temp2($_0) {
  return $_0.title;
}
function _temp3($_1) {
  return $_1.description;
}
function _temp4($_2) {
  return $_2.authTokenForm.toggle;
}
function _temp5($_3) {
  return $_3.newToFootprint;
}
function _temp6($_4) {
  return $_4.requestDemo;
}